<template>
  <div>
    <v-card
      
      outlined
      style="max-height: 30vh;overflow-y: scroll;"
    >
      <v-card-subtitle>処分加入者</v-card-subtitle>
      <template
        v-for="disposal in tenant.disposal_subscribers_attributes"
      >
        <v-card-text
          v-if="!disposal._destroy"
          :key="disposal.key"
        >
          <v-row
            dense
          >
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (disposal.subscriber_number), alpha_num_only: true, length: 7, subscriberNumberInitialsCheck: {mode: 'admin_disposer', contract_type: contractUnitType}}"
                :vid="`subscriber_number-${disposal.key}`"
                class="requiredMark"
                name="加入者番号"
              >
                <v-text-field
                  v-model="disposal.subscriber_number"
                  :error-messages="errors"
                  label="加入者番号"
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>加入者番号</span>
                    <span class="ml-1">
                      ({{ disposal.subscriber_number?.length || 0 }} / 7)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (disposal.confirmation_number), numeric: true, length: 6}"
                :vid="`confirmation_number-${disposal.key}`"
                class="requiredMark"
                name="公開確認番号"
              >
                <v-text-field
                  v-model="disposal.confirmation_number"
                  :error-messages="errors"
                  label="公開確認番号"
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>公開確認番号</span>
                    <span class="ml-1">
                      ({{ disposal.confirmation_number?.length || 0 }} / 6)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (disposal.edi_usage_key), numeric: true, length: 8}"
                :vid="`edi_usage_key-${disposal.key}`"
                class="requiredMark"
                name="EDI利用確認キー"
              >
                <v-text-field
                  v-model="disposal.edi_usage_key"
                  :error-messages="errors"
                  label="EDI利用確認キー"
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>EDI利用確認キー</span>
                    <span class="ml-1">
                      ({{ disposal.edi_usage_key?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            
            <v-col
              cols="12"
              md="2"
              class="text-right"
            >
              <v-btn
                :disabled="disableRemoveButton"
                class="error"
                small
                @click="removeButtonClickEvent(disposal)"
              >
                削除
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="mt-2" />
        </v-card-text>
      </template>
    </v-card>
    <br />
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary"
          small
          @click="addButtonClickEvent"
        >
          追加
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'DisposalSubscriberForm',
  components: {},
  mixins: [],
  props: {
    tenant: {
      type: Object,
      default: () => null,
    },
    contractUnitType: {
      type: String,
      default: "trial_contract"
    },
  },
  computed: {
    disableRemoveButton () {
      if (this.tenant.mode === 'disposal') {
        return false;
      }
      const validItems = this.tenant.disposal_subscribers_attributes.filter( v => !v._destroy)
      return validItems.length <= 1
    }
  },
  watch: {},
  created() {
  },
  methods: {
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$emit('addButtonCallback')
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    removeButtonClickEvent (item) {
      this.$emit('removeButtonCallback', item)
    },

  }
}
</script>
